import {createRouter, createWebHashHistory} from 'vue-router';
//CONTENEDORES
import AppWrapper from './AppWrapper.vue'

//HOME
const Home = () => import('./pages/Home.vue')

//info-roles
const InfoEspeciales = () => import('./views/info_roles/Especiales.vue')
const InfoGenerador = () => import('./views/info_roles/Generador.vue')
const InfoProveedor = () => import('./views/info_roles/Proveedor.vue')
const InfoTerceros = () => import('./views/info_roles/Terceros.vue')
const InfoTransporte = () => import('./views/info_roles/Transporte.vue')

//ESPECIALES
const AppEspeciales = () => import('./AppEspecial.vue')
const SelectempresaEspeciales = () => import('./views/especiales/Selectempresa.vue')

//GENERADOR
const SelectempresaGenerador = () => import('./views/generador/Selectempresa.vue')
const PendientesGenerador = () => import('./views/generador/pendientes.vue')
const VentasGenerador = () => import('./views/generador/ventas.vue')
const MovTransporte = () => import('./views/generador/MovTransporte.vue')
const ViajesGenerador = () => import('./views/generador/Viajes.vue')
const InfoDetalles = () => import('./views/generador/InfoDetalles.vue')
    //EPAYCO
    const Respuesta = () => import('./views/generador/respuestas_epayco/Respuesta.vue')
    

//EMPRESAS DE TRANSPORTE
const SelectempresaEmpresaTransporte = () => import('./views/EmpresaTransporte/Selectempresa.vue')
const PendientesEmpresaTransporte = () => import('./views/EmpresaTransporte/pendientes.vue')

const DetalleMovimiento = () => import('./views/EmpresaTransporte/components/DetalleMovimiento')
const Viajes = () => import('./views/EmpresaTransporte/viajes.vue')
const ViajesSeway = () => import('./views/EmpresaTransporte/viajesSeway.vue')
const LegalizacionGastos = () => import('./views/EmpresaTransporte/legalizacionGastos.vue')

  // CONFIGURACIONES
  const Configuracion = () => import('./views/EmpresaTransporte/configuracion.vue')
  const Eventos = () => import('./views/EmpresaTransporte/configuraciones/eventos.vue')
  const ConfigPesv = () => import('./views/EmpresaTransporte/configuraciones/ConfigPesv.vue')
  const TipoGastos = () => import('./views/EmpresaTransporte/configuraciones/TipoGastos.vue')
  const MotivosAnulacion = () => import('./views/EmpresaTransporte/configuraciones/MotivosAnulacion.vue')
  const Perfiles = () => import('./views/EmpresaTransporte/configuraciones/Perfiles.vue')
  const Usuarios = () => import('./views/EmpresaTransporte/configuraciones/Usuarios.vue')
  const Webhooks = () => import('./views/EmpresaTransporte/configuraciones/Webhooks.vue')
  const AdminFirmas = () => import('./views/EmpresaTransporte/configuraciones/documentos/firmas.vue')

    // RNDC
    const Terceros = () => import('./views/EmpresaTransporte/configuraciones/rndc/terceros.vue')
    const Vehiculos = () => import('./views/EmpresaTransporte/configuraciones/rndc/vehiculos.vue')

  //JORNADA LABORAL
  // const JornadaLaboral = () => import('./views/EmpresaTransporte/jornadalaboral/jornadalaboral.vue')
  const JornadaUsuarios = () => import('./views/EmpresaTransporte/jornadalaboral/usuarios.vue')
  const JornadaTurnos = () => import('./views/EmpresaTransporte/jornadalaboral/turnos.vue')
  const JornadaPlantillas = () => import('./views/EmpresaTransporte/jornadalaboral/plantillas.vue')
  const JornadaInformes = () => import('./views/EmpresaTransporte/jornadalaboral/informes.vue')

  //RECURSOS
  const HvConductores = () => import('./views/EmpresaTransporte/recursos/conductores.vue')
  const HvVehiculos = () => import('./views/EmpresaTransporte/recursos/vehiculos.vue')

  //Aprobaciones
  const Aprobaciones = () => import('./views/EmpresaTransporte/aprobaciones.vue')

//SUPER ADMINISTRADOR ERP
const SelectempresaSuperAdmin = () => import('./views/SuperAdmin/Inicio.vue')
const ClientesSuperAdmin = () => import('./views/SuperAdmin/clientes.vue')
const UsuariosSuperAdmin = () => import('./views/SuperAdmin/usuarios.vue')

const Inicio = () => import('./components/Inicio.vue')
const routes = [
    // Seway Plus Negocios: landing pública de publicidad para comercios.
    // Van SIN meta a propósito. Con requiresVisitor el guard de main.js redirige
    // al dashboard a quien tenga sesión abierta, y esta landing debe poder verse
    // siempre, también desde un enlace compartido por un usuario ya autenticado.
    {
        path: '/negocios',
        name: 'negocios-landing',
        component: () => import('./landing/negocios/NegociosLanding.vue')
    },
    // Ruta antigua (pantalla puente que solo enviaba un correo). Se conserva
    // como redirección para no romper enlaces ya compartidos, preservando el
    // ?plan= que llega desde la sección de planes de la landing.
    {
        path: '/registrar-negocio',
        name: 'registrar-negocio',
        redirect: (to) => ({ path: '/negocios/registro', query: to.query })
    },
    // Registro e inicio de sesión de anunciantes. Sesión propia, aislada del
    // ERP: el control de acceso lo hace cada componente contra registro/sesion.js,
    // no el guard de main.js. Por eso van igualmente SIN meta.
    {
        path: '/negocios/registro',
        name: 'negocios-registro',
        component: () => import('./landing/negocios/registro/RegistroAnunciante.vue')
    },
    {
        path: '/negocios/login',
        name: 'negocios-login',
        component: () => import('./landing/negocios/registro/LoginAnunciante.vue')
    },
    {
        path: '/negocios/portal',
        name: 'negocios-portal',
        component: () => import('./landing/negocios/registro/PortalNegocios.vue')
    },
    {
        path: '/politica-privacidad',
        name: 'politica-privacidad',
        component: () => import('./landing/negocios/PaginaLegal.vue')
    },
    {
        path: '/terminos-condiciones',
        name: 'terminos-condiciones',
        component: () => import('./landing/negocios/PaginaLegal.vue')
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/info-especiales',
        name: 'info-especiales',
        component: InfoEspeciales,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/info-generadores',
        name: 'info-generadores',
        component: InfoGenerador,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/info-proveedores',
        name: 'info-proveedores',
        component: InfoProveedor,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/info-terceros',
        name: 'info-terceros',
        component: InfoTerceros,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/info-transporte',
        name: 'info-transporte',
        component: InfoTransporte,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/',
        redirect: '/home',
        name: 'spinner',
        component: () => import('./pages/Spinner.vue'),
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue'),
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/pendiente-activacion',
        name: 'pendiente-activacion',
        component: () => import('./pages/PendienteActivacion.vue')
    },
    {
        path: '/pasarela',
        name: 'pasarela',
        component: () => import('./pages/PasarelaRegistro.vue')
    },
    {
        path: '/registrar-servicios-especiales',
        name: 'servicios-especiales',
        component: () => import('./registros/RegistroEspeciales.vue')
    },
    {
        path: '/registrar-generadores',
        name: 'generadores-registro',
        component: () => import('./registros/RegistroGeneradores.vue')
    },
    {
        path: '/registrar-empresas-transporte',
        name: 'empresas-transporte-register',
        component: () => import('./registros/RegistroEmpresas.vue')
    },
    {
        path: '/resetpassword',
        name: 'resetpassword',
        component: () => import('./pages/ResetPaswword.vue')
    },
    {
        path: '/consulta-documento-cliente',
        name: 'consulta-documento-cliente',
        component: () => import('./components/ConsultaDocumentoCliente.vue')
    },
    {
        path: '/respuesta-epayco',
        name: 'respuesta-epayco',
        component: Respuesta
    },
    {
        path: '/emailverify',
        name: 'EmailVerified',
        component: () => import('./pages/EmailVerified.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('./pages/Access.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/emailverify_password',
        name: 'emailverify_password',
        component: () => import('./pages/AccessPassword.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/especiales',
        redirect: '/especiales/select-customer',
        name: 'Especiales',
        component: AppWrapper,
        meta: {
          requiresAuth: true,
        },
        children: [
            {
                path: 'select-customer',
                name: 'select-customer',
                component: SelectempresaEspeciales
            },
            {
                path: 'inicio',
                name: 'inicio',
                component: Inicio
            },
            {
                path: 'editar-perfil',
                name: 'editperfil_especiales',
                component: () => import('./components/EditPerfil.vue')
            },
            {
                path: 'centros-costos',
                name: 'centros-costos',
                component: () => import('./maestros/CentrosCostos.vue')
            },
            {
                path: 'origenes-destinos',
                name: 'origenes-destinos',
                component: () => import('./maestros/OrigenesDestinos.vue')
            },
            {
                path: 'funcionarios',
                name: 'funcionarios',
                component: () => import('./maestros/Funcionarios.vue')
            },
            {
                path: 'solicitudes-transporte-especial',
                name: 'solicitudes-transporte-especial',
                component: () => import('./servicios/SolicitudesEspeciales.vue')
            },
            {
                path: 'historicos-solicitudes-transporte-especial',
                name: 'historicos-solicitudes-transporte-especial',
                component: () => import('./servicios/HistoricosSolicitudesEspeciales.vue')
            }
        ]
    },
    {
        path: '/generador',
        redirect: '/generador/inicio',
        name: 'Generador',
        component: AppWrapper,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: 'inicio',
            name: 'inicio-generador',
            component: SelectempresaGenerador
          },
          {
            path: 'pendientes',
            name: 'pendientes-generador',
            component: PendientesGenerador
          },
          {
            path: 'ventas',
            name: 'ventas-generador',
            component: VentasGenerador
          },
          {
            path: 'editar-perfil',
            name: 'editperfil_generador',
            component: () => import('./components/EditPerfil.vue')
           },
           {
            path: 'mov-transporte',
            name: 'mov-transporte',
            component: MovTransporte
           },
           {
            path: 'viajes',
            name: 'viajes-generador',
            component: ViajesGenerador
           },
           {
            path: 'info-detalles',
            name: 'info-detalles',
            component: InfoDetalles
           },
           {
              path: 'hv-conductores',
              name: 'hv-conductores-generador',
              component: HvConductores
            },
            {
              path: 'hv-vehiculos',
              name: 'hv-vehiculos-generador',
              component: HvVehiculos
            },
            {
              path: 'configuracion/webhooks',
              name: 'webhooks-generador',
              component: Webhooks
            },
        ]
      },
      {
        path: '/empresa-transporte',
        redirect: '/empresa-transporte/inicio',
        name: 'EmpresaTransporte',
        component: AppWrapper,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: 'inicio',
            name: 'inicio-empresa-transporte',
            component: SelectempresaEmpresaTransporte
          },
          {
            path: 'pendientes',
            name: 'pendientes-empresa-transporte',
            component: PendientesEmpresaTransporte
          },
          {
            path: 'aprobaciones',
            name: 'aprobaciones',
            component: Aprobaciones
          },
          // {
          //   path: 'configuracion',
          //   name: 'configuracion',
          //   component: Configuracion
          // },
          // {
          //   path: 'configuracion-eventos',
          //   name: 'configuracion-eventos',
          //   component: Eventos
          // },
          {
            path: 'detallemovimiento',
            name: 'detallemovimiento',
            component: DetalleMovimiento
          },
          {
            path: 'viajes',
            name: 'viajes',
            component: Viajes
          },
          {
            path: 'viajes-seway',
            name: 'viajes-seway',
            component: ViajesSeway
          },
          {
            path: 'hv-conductores',
            name: 'hv-conductores',
            component: HvConductores
          },
          {
            path: 'hv-vehiculos',
            name: 'hv-vehiculos',
            component: HvVehiculos
          },
          {
            path: 'legalizacion-gastos',
            name: 'legalizacion-gastos',
            component: LegalizacionGastos
          },
          {
            path: 'usuarios',
            name: 'usuarios-jornada-laboral',
            component: JornadaUsuarios
          },
          {
            path: 'turnos',
            name: 'turnos-jornada-laboral',
            component: JornadaTurnos
          },
          {
            path: 'plantillas',
            name: 'plantillas-jornada-laboral',
            component: JornadaPlantillas
          },
          {
            path: 'informes',
            name: 'informes-jornada-laboral',
            component: JornadaInformes
          },
          {
            path: 'configuracion',
            name: 'configuracion',
            component: Configuracion,
            children: [
              {
                path: 'eventos',
                name: 'eventos',
                component: Eventos
              },
              {
                path: 'pesv',
                name: 'pesv',
                component: ConfigPesv
              },
              {
                path: 'tipo-gastos',
                name: 'tipo-gastos',
                component: TipoGastos
              },
              {
                path: 'motivos-anulacion',
                name: 'motivos-anulacion',
                component: MotivosAnulacion
              },
              {
                path: 'usuarios',
                name: 'usuarios-jornada-laboral',
                component: JornadaUsuarios
              },
              {
                path: 'perfiles',
                name: 'perfiles',
                component: Perfiles
              },
              {
                path: 'admin-usuarios',
                name: 'admin-usuarios',
                component: Usuarios
              },
              {
                path: 'webhooks',
                name: 'webhooks',
                component: Webhooks
              },
              {
                path: 'terceros',
                name: 'terceros',
                component: Terceros
              },
              {
                path: 'vehiculos',
                name: 'vehiculos',
                component: Vehiculos
              },
              {
                path: 'admin-firmas',
                name: 'admin-firmas',
                component: AdminFirmas
              },
              // {
              //   path: 'informes',
              //   name: 'informes-jornada-laboral',
              //   component: JornadaInformes
              // },
            ]
          },
          
          {
            path: 'editar-perfil',
            name: 'editperfil_empresa',
            component: () => import('./components/EditPerfil.vue')
           }
        ]
      },
      {
        path: '/super-administrador',
        redirect: '/super-administrador/inicio',
        name: 'SuperAdmin',
        component: AppWrapper,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: 'inicio',
            name: 'inicio-super-administrador',
            component: SelectempresaSuperAdmin
          },
          {
            path: 'clientes',
            name: 'clientes-administrador',
            component: ClientesSuperAdmin
          },
          {
            path: 'usuarios',
            name: 'usuarios-administrador',
            component: UsuariosSuperAdmin
          },
          {
            path: 'editar-perfil',
            name: 'editperfil_superadmin',
            component: () => import('./components/EditPerfil.vue')
           }
        ]
      },
    { 
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('./pages/NotFound.vue') 
    },
    { 
        path: '/prueba-login',
        name: 'prueba-login',
        component: () => import('./pages/prueba_login.vue') 
    },
];


const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 };
    }
});

export default router;
